// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import store from './store'

require('../assets/icon/iconfont.js')

let clientWidth = document.body.clientWidth;

let isMobile = clientWidth < 600 || navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) || false;


Vue.prototype.isMobile = isMobile;


import router from './router';
import mobileRouter from './router/mobile.js';

// import {  } from 'element-ui';
// import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
// import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/lib/theme-chalk/base.css';
// import '../assets/style/element.scss'

// Vue.prototype.$message = Message; 
// Vue.prototype.$confirm = MessageBox.confirm;

import VueResource from 'vue-resource';
Vue.use(VueResource);
Vue.http.options.emulateJSON = false;
Vue.http.options.xhr = { withCredentials: true }

import services from '@/services/services.js'
Vue.prototype.service = services;

Vue.http.interceptors.push((request, next) => {
  // modify request
  // request.method = 'POST';//在请求之前可以进行一些预处理和配置
  // continue to next interceptor
  //在响应之后传给then之前对response进行修改和逻辑判断。对于session已过期的判断，就添加在此处，页面中任何一次http请求都会先调用此处方法
　　next((response) => {
        // loading  =  false// loading隐藏，一般在vuex里控制
        if(response.status === 200) {
              // ... //处理请求成功的逻辑
              if(response.body.code == '401'){
                // router.push('/login')
              }
              return response // 必须返回，后面的接口的then，才能获取response
        }  else { 
            if (response.status >= 500) {
                // 错误处理
                // router.push('/login')
            } else if (response.status === 401) {
              // ...
              // router.push('/login')
            }
            return response // 必须返回
        }
  });
});
 
// Vue.component(CollapseTransition.name, CollapseTransition)
/* eslint-disable no-new */

// filters
import './filters'

require('../assets/style/font.css');

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
new Vue({
  el: '#app',
  router: isMobile ? mobileRouter : router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/modules/main.js